import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { isCompanyAdmin } from '@/types';
import Sidebar from '@/components/common/Sidebar';
import { AlertTriangle, HelpCircle } from 'lucide-react';

type Props = { children: React.ReactNode };

export default function PosAccessGuard({ children }: Props) {
  const { canUsePOS, role, company } = useAuthStore();

  if (canUsePOS) return <>{children}</>;

  const admin = isCompanyAdmin(role);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="card p-8 max-w-md text-center">
          <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">POS Access Unavailable</h2>
          <p className="text-sm text-gray-500 mb-6">
            {company?.status === 'Trial Expired'
              ? 'Your trial and grace period have ended. Subscribe to continue using the POS. Your data is retained for a limited time.'
              : company?.status === 'Suspended'
                ? 'Your subscription and grace period have ended. Renew to restore POS access. Your data is retained for a limited time.'
                : 'Your subscription is not active. POS billing is currently disabled.'}
          </p>
          {admin ? (
            <Link to="/support" className="btn-primary inline-flex items-center gap-2">
              <HelpCircle className="w-4 h-4" /> Contact Support
            </Link>
          ) : (
            <p className="text-sm text-gray-600">
              Please contact your Company Admin to renew the subscription.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
